import angular from 'angular';
import {fskTrans} from 'acng/userPool/0fsk.js';
import {user} from '../../user/user.js';
import {asset} from '../../core/service/env.js';
import templateUrl from '../../../html/amateurPool/moreAboutMe.html';

angular.module('amateurPool').component('onswMoreAboutMe', {
  bindings: {amateur: '<'},
  templateUrl: asset(templateUrl),
  controller: [
    '$scope',
    /**
     * @this {angular.IController & {amateur: import('../model/amateur').Amateur}}
     * @param {angular.IScope & {
     *   hasAboutMe: () => boolean;
     *   hasOthersAboutMe: () => boolean;
     *   hasFantasies: () => boolean;
     *   fsk: 18 | 16 | 12;
     * }} $scope
     */
    function ($scope) {
      $scope.fsk = user.fsk;
      /**
       * @param {"about_me" | "others_about_me" | "fantasies"} key
       */
      const has = (key) => this.amateur && !!fskTrans(this.amateur[key]);
      $scope.hasAboutMe = () => has('about_me');
      $scope.hasOthersAboutMe = () => has('others_about_me');
      $scope.hasFantasies = () => has('fantasies');
    },
  ],
});
